export default {
  title: 'Télécharger l\'application',
  author: ' Investia',
  buttonLabel: 'Installer',
  closeButtonLabel: 'Fermer',
};
